<template>
  <div class="record-select-box">
    <select v-model="record" @change="recordOnChange">
      <option v-for="option in RecordOptions" :key="option">
        {{
        option
        }}
      </option>
    </select>
  </div>
</template>

<script>
import { RecordOptions } from "../../../js/fields";

export default {
  props: ["record"],

  data() {
    return {
      RecordOptions
    };
  },

  methods: {
    recordOnChange({ target: { value } }) {
      this.$emit("changeRecord", value);
    }
  }
};
</script>

<style lang="scss">
.record-select-box {
  select {
    width: 63px;
    height: 25px;
    padding-left: 17px;
    border-radius: 2px;
    border: solid 1px #ebebeb;
    font-size: 13px;
    color: #333;
    outline: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    background-image: url("../../../assets/img/select.svg");
    // background-size: 0.6em;
    background-position: calc(100% - 0.8em) center;
    background-repeat: no-repeat;
    background-color: #ffffff;
    cursor: pointer;

    &::-ms-expand {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contents/shared/RecordSelectBox.vue